import { Component, OnInit, EventEmitter, ViewChild, ViewEncapsulation, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CppPriceListService } from '../../../services/cpp/cpp-price-list.service';
import { ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CppManageSubscription } from '../../../services/cpp/cpp-price-list-manage-subscription.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MasterConstants } from './../../../common/constants/master-constants';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';

@Component({
  selector: 'app-cpp-pricelist-manage-subscription',
  templateUrl: './cpp-pricelist-manage-subscription.component.html',
  styleUrls: ['./cpp-pricelist-manage-subscription.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppPricelistManageSubscriptionComponent implements OnInit, OnDestroy {
  private subscription = new Array<Subscription>();

  subscriptionTypeList: any = [{ id: 'C', value: 'SPECIAL PRICED ITEMS' }, { id: 'A', value: 'All Items' }, { id: 'F', value: 'FAVORITE ITEMS' }];
  priceChangeOnlyList: any = [{ id: 1, value: 'OFF' }, { id: 1, value: 'ON' }];
  searchTypeList = ['User Name', 'User Id', 'Email Id', 'Price Change Only', 'Subscription Type'];
  userNameList: any;
  userIdList: any;
  emailList: any;
  apiData: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  selectedFilter: string = this.searchTypeList[0];
  filtersValue: any;
  filterValueList: any[] = [];
  accountName: string;
  accountNo: string;
  isStatus: string;
  subscriptionType = 'A';
  changesOnly = 'N';
  displayAPR = 'Y';
  selectedCount = 0;
  editToolKit = false;
  allChecked = false;
  totalRows = 0;
  pageIndex = 0;
  totalEditableRows = 0;
  isSubClick = false;
  isSubBulkClick = false;
  isUnSubBulkClick = false;
  isSubsModalShow = false;
  isSubsBtnModalShow = false;
  isUnSubsBtnModalShow = false;
  isSubscribeBulk = true;
  bulkSubscriptionType: string;
  bulkChangesOnly: string;
  subscriptionTypeFlag: string;
  changesOnlyFlag: string;
  bulkDisplayAPROnly: string;
  termchangesOnly = 'N';
  pricechangesOnly = 'N';
  changeType = 'Term Or Price';
  mySubscriptionDisplayItemToggle = 'all';
  manageSubscriptionDisplayItemToggle = 'all';
  displayText = 'ALL ITEMS';
  masterConstants = MasterConstants;
  plManageSubColumns: string[] = ['checkbox', 'userName', 'userId', 'email', 'showChanges', 'changeType', 'subscriptionType', 'displayAPR', 'status'];
  plManageSubDataSource: MatTableDataSource<any>;
  @ViewChild('placedCPPOrdersTable', { read: MatSort }) productListSort: MatSort;
  @ViewChild('productListPaginator', { read: MatPaginator }) productListPaginator: MatPaginator;

  constructor(private cppPriceListService: CppPriceListService,
    private cppManageSubscription: CppManageSubscription,
    private activeRoute: ActivatedRoute,
    private loaderService: LoaderService,
    private toastrService: ToastrService,
    private cd: ChangeDetectorRef,
    private localStorageService: LocalStorageService) {
    this.filtersValue = {};
    // Set account number if passed in url
    this.subscription.push(this.activeRoute.params.subscribe(params => {
      const id = params['accountNo'];
      this.accountNo = id ? id : 0;
    }));
  }

  ngOnInit() {
    this.accountName = this.cppPriceListService.accountName;
    this.plManageSubDataSource = new MatTableDataSource([]);
    this.plManageSubDataSource.paginator = this.productListPaginator;
    this.plManageSubDataSource.sortingDataAccessor = (item, property) => {
      if (item[property] == null || item[property] == '') {
        if (this.plManageSubDataSource.sort.direction == 'desc') { return '\u0000' + '\u0000' + '\u0000'; }
        return '\uFFFF' + '\uFFFF' + '\uFFFF';
      }
      return item[property];
    };
    this.plManageSubDataSource.sort = this.productListSort;
    this.getManageSubscriptionList();
    this.getSubscriptionStatus();
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly = 'N';
    }
  }

  // Keep the filter values
  keepFilter() {
    // Create filterValueList from Filters
    this.filterValueList = [];

    if (this.filtersValue.userName && this.filtersValue.userName != '') {
      this.filterValueList.push({ column: 'userName', filterlabel: 'User Name : ' + this.filtersValue.userName, data: this.filtersValue.userName });
    }
    if (this.filtersValue.userId && this.filtersValue.userId != '') {
      this.filterValueList.push({ column: 'userId', filterlabel: 'User Id : ' + this.filtersValue.userId, data: this.filtersValue.userId });
    }
    if (this.filtersValue.emailId && this.filtersValue.emailId != '') {
      this.filterValueList.push({ column: 'emailId', filterlabel: 'Email Id : ' + this.filtersValue.emailId, data: this.filtersValue.emailId });
    }
    if (this.filtersValue.priceChangeOnly && this.filtersValue.priceChangeOnly != '') {
      this.filterValueList.push({ column: 'priceChangeOnly', filterlabel: 'Price Change Only : ' + this.filtersValue.priceChangeOnly, data: this.filtersValue.priceChangeOnly });
    }
    if (this.filtersValue.subscriptionType && this.filtersValue.subscriptionType != '') {
      this.filterValueList.push({ column: 'subscriptionType', filterlabel: 'Subscription Type : ' + this.filtersValue.subscriptionType, data: this.filtersValue.subscriptionType });
    }
  }

  // Clear all filter
  clearAllFilter() {
    if (this.filterValueList.length > 0) {
      this.filterValueList = new Array();
      this.resetFilterInputValue();
      this.filterData();
    }
  }

  // Reset the filter values
  resetFilterInputValue() {
    this.filtersValue.userName = null;
    this.filtersValue.userId = null;
    this.filtersValue.emailId = null;
    this.filtersValue.priceChangeOnly = null;
    this.filtersValue.subscriptionType = null;
  }

  // Clear selected filter
  clearFilter(column: string) {
    this.removeSelectedFilter(column);
    this.filterValueList = this.filterValueList.filter(x => column.trim() != x.column.trim());
    this.filterData();
  }

  // To remove/clear selected chip search filter
  removeSelectedFilter(filterValue) {
    switch (filterValue) {
      case 'userName':
        this.filtersValue.userName = null;
        break;
      case 'userId':
        this.filtersValue.userId = null;
        break;
      case 'emailId':
        this.filtersValue.emailId = null;
        break;
      case 'priceChangeOnly':
        this.filtersValue.priceChangeOnly = null;
        break;
      case 'subscriptionType':
        this.filtersValue.subscriptionType = null;
        break;
      default:
        break;
    }
  }

  // Get data for Manage subscription
  getManageSubscriptionList() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppManageSubscription.getManageSubscriptionList(this.accountNo).subscribe((result: any) => {
      result.cppManageSubscriptionData.filter(x => {
        x.isNonEditable = x.email == '' ? true : false;
        x.displayAPR = x.aprFlag;
      });

      this.totalRows = result.cppManageSubscriptionData.length;
      this.apiData = result.cppManageSubscriptionData;
      this.plManageSubDataSource = new MatTableDataSource(result.cppManageSubscriptionData);
      this.plManageSubDataSource.paginator = this.productListPaginator;
      this.productListPaginator.firstPage();
      this.plManageSubDataSource.sortingDataAccessor = (item, property) => {
        if (item[property] == null || item[property] == '') {
          if (this.plManageSubDataSource.sort.direction == 'desc') { return '\u0000' + '\u0000' + '\u0000'; }
          return '\uFFFF' + '\uFFFF' + '\uFFFF';
        }
        return item[property];
      };
      this.plManageSubDataSource.sort = this.productListSort;
      $('.mat-mdc-paginator-page-size').hide();
      const list = document.getElementsByClassName('mat-mdc-paginator-range-label');
      const currentPage = this.totalRows > 0 ? 1 : 0;
      list[0].innerHTML = 'Page: ' + currentPage + ' of ' + Math.ceil((this.totalRows / 50));

      this.userNameList = result.userNameList;
      this.emailList = result.emailList;
      this.userIdList = result.userIdList;
      this.filterData();
      this.totalEditableRows = this.plManageSubDataSource.data.filter(x => x.isNonEditable == false).length;
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  // Show or hide Subscription Modal
  showHideSubscription() {
    this.isSubClick = true;
    this.isSubsModalShow = !this.isSubsModalShow;
    this.changesOnly = (this.isStatus == 'Unsubscribed' ? 'N' : this.changesOnly);
    this.subscriptionType = (this.isStatus == 'Unsubscribed' ? 'A' : this.subscriptionType);
    this.setTriToggleMySubscription();
  }

  // Get Subscription My Status
  getSubscriptionStatus() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppManageSubscription.getSubscriptionStatus(this.accountNo).subscribe(result => {
      this.isStatus = result.status;
      this.accountName = result.accountName;
      this.changesOnly = result.changesOnly;
      this.getSubscriptionStatusWithChangeType(result.changeType);
      this.displayAPR = result.aprFlag;
      this.subscriptionType = result.subscriptionType;
      this.changesOnlyFlag = result.changesOnly;
      this.subscriptionTypeFlag = result.subscriptionType;
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  getSubscriptionStatusWithChangeType(type: string) {
    switch (type) {
      case 'Price':
        this.changesOnly = 'Y';
        this.pricechangesOnly = 'Y';
        this.termchangesOnly = 'N';
        break;
      case 'Term':
        this.changesOnly = 'Y';
        this.pricechangesOnly = 'N';
        this.termchangesOnly = 'Y';
        break;
      case 'Term Or Price':
        this.changesOnly = 'Y';
        this.pricechangesOnly = 'Y';
        this.termchangesOnly = 'Y';
        break;
      default:
        this.changesOnly = 'N';
        this.pricechangesOnly = 'N';
        this.termchangesOnly = 'N';
        break;
    }
  }

  // Change My Status for Subscription
  changeStatus(update: boolean = false) {
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly == 'N';
    }
    this.isSubsModalShow = false;
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppManageSubscription.updateStatus(this.accountNo, this.subscriptionType, this.changesOnly, this.displayAPR, this.changeType, update).subscribe(result => {
      if (result && result == true) {
        if (update == false) {
          this.isStatus = (this.isStatus == 'Subscribed' ? 'Unsubscribed' : 'Subscribed');
          this.changesOnly = (this.isStatus == 'Unsubscribed' ? 'N' : this.changesOnly);
          this.subscriptionType = (this.isStatus == 'Unsubscribed' ? 'A' : this.subscriptionType);
        }
        this.changesOnlyFlag = this.changesOnly;
        this.subscriptionTypeFlag = this.subscriptionType;
        this.getManageSubscriptionList();
      }
      else {
        this.toastrService.error('Email address is required for subscription.');
      }
      this.loaderService.setLoaderStatus(false);
    }, (error => {
      this.loaderService.setLoaderStatus(false);
    })));
  }

  //Tri state toggle for MySubscription
  changeForMySubscription() {
    if (this.mySubscriptionDisplayItemToggle == 'all') {
      this.mySubscriptionDisplayItemToggle = 'special';
      this.subscriptionType = 'C';
    } else if (this.mySubscriptionDisplayItemToggle == 'special') {
      this.mySubscriptionDisplayItemToggle = 'favorite';
      this.subscriptionType = 'F';
    } else if (this.mySubscriptionDisplayItemToggle == 'favorite') {
      this.mySubscriptionDisplayItemToggle = 'all';
      this.subscriptionType = 'A';
    }
    this.cd.detectChanges();
  }

  // Change the toggle value for Pop up
  toggleForSpecialItemDisplayPopup() {
    this.subscriptionType = this.subscriptionType == 'C' ? 'A' : 'C';
  }

  // Change the toggle value for Pop up
  toggleForDisplayAPRPopup() {
    this.displayAPR = this.displayAPR == 'Y' ? 'N' : 'Y';
  }

  // Change the toggle value for Pop up
  toggleForchangesOnlyPopup() {
    this.changesOnly = this.changesOnly == 'Y' ? 'N' : 'Y';
    if (this.changesOnly == 'N') {
      this.termchangesOnly = 'N';
      this.pricechangesOnly = 'N';
    }
    else {
      this.termchangesOnly = 'Y';
      this.pricechangesOnly = 'Y';
    }

    this.SetChangeType();
  }

  toggleForTermChangesOnly() {
    this.termchangesOnly = this.termchangesOnly == 'Y' ? 'N' : 'Y';
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly = 'N';
      this.bulkChangesOnly = 'N';
      this.isSubClick = true;
      this.isSubBulkClick = true;
    }
    this.SetChangeType();
  }

  toggleForPriceChangesOnlyPopup() {
    this.pricechangesOnly = this.pricechangesOnly == 'Y' ? 'N' : 'Y';
    if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'N') {
      this.changesOnly = 'N';
      this.bulkChangesOnly = 'N';
      this.isSubClick = true;
      this.isSubBulkClick = true;
    }
    this.SetChangeType();
  }

  SetChangeType() {
    if (this.termchangesOnly == 'Y' && this.pricechangesOnly == 'Y') {
      this.changeType = 'Term Or Price';
    }
    else if (this.termchangesOnly == 'Y' && this.pricechangesOnly == 'N') {
      this.changeType = 'Term';
    }
    else if (this.termchangesOnly == 'N' && this.pricechangesOnly == 'Y') {
      this.changeType = 'Price';
    }
    else {
      this.changeType = 'Term Or Price';
    }
  }

  // Close the pop up on No action
  closePopup() {
    if (!this.isSubClick) {
      this.isSubsModalShow = false;
    }
    this.changesOnly = (this.isStatus == 'Unsubscribed' ? 'N' : this.changesOnlyFlag);
    this.subscriptionType = (this.isStatus == 'Unsubscribed' ? 'A' : this.subscriptionTypeFlag);
    this.isSubClick = false;
  }

  // Show Hide the bulk subscribed pop up
  showHideSubsWindow() {
    this.isSubBulkClick = true;
    this.bulkChangesOnly = 'N';
    this.bulkSubscriptionType = 'A';
    this.isSubscribeBulk = true;
    this.isSubsBtnModalShow = true;
    this.bulkDisplayAPROnly = 'Y';
    this.manageSubscriptionDisplayItemToggle = 'all';
    this.displayText = 'ALL ITEMS';
  }

  // Close subscribed pop up on No
  closeSubscribePopup() {
    if (!this.isSubBulkClick) {
      this.isSubsBtnModalShow = false;
    }
    this.isSubBulkClick = false;
  }

  // Tri state toggle for ManageSubscription.
  changeForManageSubscription() {
    if (this.manageSubscriptionDisplayItemToggle == 'all') {
      this.manageSubscriptionDisplayItemToggle = 'special';
      this.displayText = 'SPECIAL PRICED ITEMS';
      this.bulkSubscriptionType = 'C';
    } else if (this.manageSubscriptionDisplayItemToggle == 'special') {
      this.manageSubscriptionDisplayItemToggle = 'favorite';
      this.displayText = 'FAVORITE ITEMS';
      this.bulkSubscriptionType = 'F';
    } else if (this.manageSubscriptionDisplayItemToggle == 'favorite') {
      this.manageSubscriptionDisplayItemToggle = 'all';
      this.displayText = 'ALL ITEMS';
      this.bulkSubscriptionType = 'A';
    }
    this.cd.detectChanges();
  }
  // Change the toggle value for bulk Pop up
  toggleForSpecialItemDisplayBulkSubPopup() {
    this.bulkSubscriptionType = this.bulkSubscriptionType == 'C' ? 'A' : 'C';
  }

  // Change the toggle value for bulk Pop up
  toggleForchangesOnlyBulkSubPopup() {
    this.bulkChangesOnly = this.bulkChangesOnly == 'Y' ? 'N' : 'Y';
    if (this.bulkChangesOnly == 'N') {
      this.termchangesOnly = 'N';
      this.pricechangesOnly = 'N';
    }
    else {
      this.termchangesOnly = 'Y';
      this.pricechangesOnly = 'Y';
    }
    this.SetChangeType();
  }

  // Change the toggle value for bulk Pop up
  toggleForDisplayAprOnlyBulkSubPopup() {
    this.bulkDisplayAPROnly = this.bulkDisplayAPROnly == 'Y' ? 'N' : 'Y';
  }

  // Show Hide the bulk unsubscribed pop up
  showHideUnSubsWindow() {
    this.isUnSubBulkClick = true;
    this.bulkChangesOnly = 'N';
    this.bulkSubscriptionType = 'A';
    this.isSubscribeBulk = false;
    this.isUnSubsBtnModalShow = true;
    this.bulkDisplayAPROnly = 'Y';
  }

  // Close unsubscribed pop up on No
  closeUnsubscribePopup() {
    if (!this.isUnSubBulkClick) {
      this.isUnSubsBtnModalShow = false;
    }
    this.isUnSubBulkClick = false;
  }

  // Change the toggle value for bulk Pop up
  toggleForSpecialItemDisplayBulkUnSubPopup() {
    this.bulkSubscriptionType = this.bulkSubscriptionType == 'C' ? 'A' : 'C';
  }

  // Change the toggle value for bulk Pop up
  toggleForchangesOnlyBulkUnSubPopup() {
    this.bulkChangesOnly = this.bulkChangesOnly == 'Y' ? 'N' : 'Y';
  }

  // Check or uncheck the single check box for all rows
  enableAllCheckBoxes(isChecked) {
    if (isChecked) {
      this.plManageSubDataSource.data.forEach(x => {
        if (x.isNonEditable == false) {
          x.isSelected = true;
        }
      });
      this.selectedCount = this.plManageSubDataSource.data.filter(x => x.isNonEditable == false).length;
    }
    else {
      this.plManageSubDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.selectedCount = 0;
    }
    const checked = this.plManageSubDataSource.data.filter(x => x.isSelected === true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
  }

  // Check or uncheck the single check box for single rows
  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.selectedCount = this.selectedCount + 1;
      const checked = this.plManageSubDataSource.data.filter(x => x.isSelected == false);
      if (checked && checked.length == 0) {
        this.allChecked = true;
      }
      else {
        this.allChecked = false;
      }
    }
    else {
      this.selectedCount = this.selectedCount - 1;
      this.allChecked = false;
    }
    const checked = this.plManageSubDataSource.data.filter(x => x.isSelected === true);
    if (checked) {
      this.editToolKit = (checked.length > 0);
    }
  }

  // Update the page number on click of next/previous
  updatePage(event?: PageEvent) {
    const list = document.getElementsByClassName('mat-mdc-paginator-range-label');
    const totalPages = this.totalRows / 50;
    if (event) {
      this.pageIndex = event && event.pageIndex;
      const newPage = (this.pageIndex + 1).toString();
      const displayValue = 'Page: ' + newPage + ' of ' + Math.ceil(totalPages);
      list[0].innerHTML = displayValue;
    } else {
      list[0].innerHTML = 'Page: ' + 0 + ' of ' + Math.ceil(totalPages);
    }
  }

  // Filter data
  filterData() {
    const userName = this.filterValueList.filter(x => x.column == 'userName').length > 0 ? this.filterValueList.filter(x => x.column == 'userName')[0].data : [];
    const userId = this.filterValueList.filter(x => x.column == 'userId').length > 0 ? this.filterValueList.filter(x => x.column == 'userId')[0].data : [];
    const emailId = this.filterValueList.filter(x => x.column == 'emailId').length > 0 ? this.filterValueList.filter(x => x.column == 'emailId')[0].data : [];
    const priceChangeOnly = this.filterValueList.filter(x => x.column == 'priceChangeOnly').length > 0 ? this.filterValueList.filter(x => x.column == 'priceChangeOnly')[0].data : null;
    const subscriptionType = this.filterValueList.filter(x => x.column == 'subscriptionType').length > 0 ? this.filterValueList.filter(x => x.column == 'subscriptionType')[0].data : null;

    this.editToolKit = false;
    this.selectedCount = 0;
    this.apiData.forEach(x => {
      x.isSelected = false;
    });

    const data = this.apiData.filter(x => ((userName.length > 0 ? userName.find(y => y.trim() == x.userName) : true) &&
      (userId.length > 0 ? userId.find(y => y.trim() == x.userId) : true) &&
      (emailId.length > 0 ? emailId.find(y => y.trim() == x.email) : true) &&
      (priceChangeOnly != null ? priceChangeOnly.trim() == x.showChanges : true) &&
      (subscriptionType != null ? subscriptionType.trim() == x.subscriptionType : true)
    ));
    this.totalRows = data.length;
    this.plManageSubDataSource = new MatTableDataSource(data);
    this.plManageSubDataSource.paginator = this.productListPaginator;
    this.productListPaginator.firstPage();
    this.plManageSubDataSource.sortingDataAccessor = (item, property) => {
      if (item[property] == null || item[property] == '') {
        if (this.plManageSubDataSource.sort.direction == 'desc') { return '\u0000' + '\u0000' + '\u0000'; }
        return '\uFFFF' + '\uFFFF' + '\uFFFF';
      }
      return item[property];
    };
    this.plManageSubDataSource.sort = this.productListSort;
    this.totalEditableRows = this.plManageSubDataSource.data.filter(x => x.isNonEditable == false).length;
    $('.mat-mdc-paginator-page-size').hide();
    const list = document.getElementsByClassName('mat-mdc-paginator-range-label');
    const currentPage = this.totalRows > 0 ? 1 : 0;
    list[0].innerHTML = 'Page: ' + currentPage + ' of ' + Math.ceil((this.totalRows / 50));
  }

  // Save Subscribed or unscribed data
  SaveSubscribedUnsubscribedData() {
    const data = this.plManageSubDataSource.data.filter(x => x.isSelected == true);
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.cppManageSubscription.addUpdateSubscription(this.isSubscribeBulk, this.bulkChangesOnly, this.bulkSubscriptionType, this.bulkDisplayAPROnly, this.changeType, data).subscribe((result: any) => {
      this.getManageSubscriptionList();
      this.getSubscriptionStatus();
      this.loaderService.setLoaderStatus(false);
      this.isSubsBtnModalShow = false;
      this.isUnSubsBtnModalShow = false;
      this.manageSubscriptionDisplayItemToggle = 'all';
      this.displayText = 'ALL ITEMS';
      if (result) {
        this.toastrService.success('Records saved successfully.');
      } else {
        this.toastrService.error('Something went wrong!');
      }
    }, (error => {
      this.isUnSubsBtnModalShow = false;
      this.isSubsBtnModalShow = false;
      this.loaderService.setLoaderStatus(false);
      this.toastrService.error('Something went wrong!');
    })));
  }

  // Toggle for MySubscription
  setTriToggleMySubscription() {
    if (this.subscriptionType == 'C') {
      this.mySubscriptionDisplayItemToggle = 'special';
    } else if (this.subscriptionType == 'F') {
      this.mySubscriptionDisplayItemToggle = 'favorite';
    } else if (this.subscriptionType == 'A') {
      this.mySubscriptionDisplayItemToggle = 'all';
    }
    this.cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
